export const getPaymentNotice = (response) => {
    const data = response?.data;
    if (typeof data === "string") {
        if (["This payment has expired", "This payment link has expired"].includes(data)) {
            return {status: "EXPIRED", message: data, transaction: {}};
        }
        return null;
    }
    if (!data || typeof data !== "object" || data.transactionPayinRequest) {
        return null;
    }

    // The nested bank result takes precedence over the HTTP/envelope failure.
    const transaction = data.transaction || {};
    const code = data.statusCode ?? transaction.statusCode;
    const status = code === "009" ? "EXPIRED" : data.status || transaction.status || {
        "000": "SUCCESS",
        "002": "PENDING",
        "004": "FAILED",
        "007": "FAILED",
    }[code];
    if (!["SUCCESS", "PENDING", "FAILED", "EXPIRED"].includes(status)) {
        return null;
    }
    const defaultMessage = {
        SUCCESS: "Already Paid",
        PENDING: "Transaction pending at bank side",
        FAILED: code === "004" ? "Bank Server error" : "Transaction failed",
        EXPIRED: "Transaction Expired, Transaction not attempted by user within time",
    };
    return {
        status,
        message: typeof data.message === "string" && data.message ? data.message : defaultMessage[status],
        transaction,
    };
};
